import { createGlobalStyle } from 'styled-components'
import { BODY_SCROLL_BAR_CLASSNAME } from './utils/helpers/UiHleper/UiHelper'
import { theme } from 'yolda-web-ui'

const GlobalStyle = createGlobalStyle`
  html, body {
    font-size: 16px;
    width: 100vw;

    @media screen and (max-width: ${theme.screens.tablet}) {
      font-size: 14px;
    }
  }

  html, body, #root {
    width: 100%;
    height: 100%;
  }

  body {
    background-color: #f7f7ff;

    &[class="${BODY_SCROLL_BAR_CLASSNAME}"] {
      max-height: 100%;
      overflow-y: hidden;
    }

    &, * {
      margin: 0;
      padding: 0;
      /* font-family: "TT Norms Pro", sans-serif; */
      font-family: "Roboto", sans-serif;
      text-rendering: optimizeLegibility;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      box-sizing: border-box;
    } 
  }

  img {
    display: block;
  }

  button {
    cursor: pointer;
    border: 0;
    outline: none;
    font-size: 1rem;
    padding: .5rem 1rem;
    border-radius: 0.25rem;
    text-align: center;
  }

  details summary {
    list-style: none;
  }

  details summary::-webkit-details-marker {
    display: none;
  }

  .grecaptcha-badge { visibility: hidden; }
`

export default GlobalStyle
